import { REDUX_API_GATEWAY_ACTIONS } from '../constants/apiGateWayConstant';

// intiate store constant
import STORE_INITIATE_VALUE from '../constants/initialstore';

export default (state = STORE_INITIATE_VALUE.NEXT_REPORT, action) => {
  switch (action.type) {
    case REDUX_API_GATEWAY_ACTIONS.GET_NEXT_REPORT_SUCCESS:
      if (
        action.payload === undefined ||
        action.payload === null ||
        Object.keys(action.payload).length === 0
      ) {
        return {
          ...state,
          reportData: {},
        };
      }
      return {
        ...state,
        reportData: action.payload.data[0].attributes.theReport,
        LastEvaluatedKey: action.payload.data[0].attributes.LastEvaluatedKey,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/nextReport.js